export default __webpack_public_path__ + "static/media/karen-press.5b2542d7.mp4";